/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemClientIdMax = 36;

export const graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemContentTypeClientIdMax = 36;

export const graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemContentTypeClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemTypeDescriptionMax = 2000;

export const graphMutationApprovalPreviewResponseCanonicalMutationEditNodesItemContentTypeClientIdMax = 36;

export const graphMutationApprovalPreviewResponseCanonicalMutationEditNodesItemContentTypeClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const graphMutationApprovalPreviewResponseCanonicalMutationEditNodesItemTypeDescriptionMax = 2000;

export const graphMutationApprovalPreviewResponseCanonicalMutationRootClientIdsItemMax = 36;

export const graphMutationApprovalPreviewResponseCanonicalMutationRootClientIdsItemRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const graphMutationApprovalPreviewResponseCanonicalMutationSetEdgesItemFromClientIdMax = 36;

export const graphMutationApprovalPreviewResponseCanonicalMutationSetEdgesItemFromClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const graphMutationApprovalPreviewResponseCanonicalMutationSetEdgesItemToClientIdMax = 36;

export const graphMutationApprovalPreviewResponseCanonicalMutationSetEdgesItemToClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');

export const GraphMutationApprovalPreviewResponse = zod.object({
  canonicalMutation: zod.object({
    addNodes: zod
      .array(
        zod.object({
          clientId: zod
            .string()
            .min(1)
            .max(graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemClientIdMax)
            .regex(graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemClientIdRegExp)
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          contentTypeClientId: zod
            .string()
            .min(1)
            .max(
              graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemContentTypeClientIdMax,
            )
            .regex(
              graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemContentTypeClientIdRegExp,
            )
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
          occurredAt: zod.string().optional(),
          subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
          typeDescription: zod
            .string()
            .min(1)
            .max(
              graphMutationApprovalPreviewResponseCanonicalMutationAddNodesItemTypeDescriptionMax,
            )
            .optional(),
          typeName: zod.string().min(1).optional(),
          value: zod
            .object({
              booleanValue: zod.boolean().nullish(),
              dateValue: zod.string().nullish(),
              datetimeValue: zod.string().nullish(),
              numericValue: zod.number().nullish(),
              stringValue: zod.string().nullish(),
            })
            .optional(),
          valueType: zod.enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME']).optional(),
          variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
        }),
      )
      .optional(),
    deleteLineageUuids: zod.array(zod.uuid().describe('UUID v4 identifier')).optional(),
    editNodes: zod
      .array(
        zod.object({
          contentTypeClientId: zod
            .string()
            .min(1)
            .max(
              graphMutationApprovalPreviewResponseCanonicalMutationEditNodesItemContentTypeClientIdMax,
            )
            .regex(
              graphMutationApprovalPreviewResponseCanonicalMutationEditNodesItemContentTypeClientIdRegExp,
            )
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
          contentUuid: zod.uuid().describe('UUID v4 identifier'),
          occurredAt: zod.string().optional(),
          subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
          typeDescription: zod
            .string()
            .min(1)
            .max(
              graphMutationApprovalPreviewResponseCanonicalMutationEditNodesItemTypeDescriptionMax,
            )
            .optional(),
          typeName: zod.string().min(1).optional(),
          value: zod
            .object({
              booleanValue: zod.boolean().nullish(),
              dateValue: zod.string().nullish(),
              datetimeValue: zod.string().nullish(),
              numericValue: zod.number().nullish(),
              stringValue: zod.string().nullish(),
            })
            .optional(),
          variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
        }),
      )
      .optional(),
    ownership: zod.enum(['user_owned', 'agent_owned']),
    removeEdges: zod
      .array(
        zod.object({
          fromContentUuid: zod.uuid().describe('UUID v4 identifier'),
          toContentUuid: zod.uuid().describe('UUID v4 identifier'),
        }),
      )
      .optional(),
    rootClientIds: zod
      .array(
        zod
          .string()
          .min(1)
          .max(graphMutationApprovalPreviewResponseCanonicalMutationRootClientIdsItemMax)
          .regex(graphMutationApprovalPreviewResponseCanonicalMutationRootClientIdsItemRegExp)
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
      )
      .optional()
      .describe(
        'Added root INSTANCE client IDs only. TYPE nodes and contained child INSTANCE nodes are not roots.',
      ),
    rootContentUuids: zod.array(zod.uuid().describe('UUID v4 identifier')).optional(),
    setEdges: zod
      .array(
        zod.object({
          carbonCopy: zod.boolean().optional(),
          certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']).optional(),
          edgeDescription: zod.string().nullish(),
          edgeKey: zod.string().nullish(),
          edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
          fromClientId: zod
            .string()
            .min(1)
            .max(graphMutationApprovalPreviewResponseCanonicalMutationSetEdgesItemFromClientIdMax)
            .regex(
              graphMutationApprovalPreviewResponseCanonicalMutationSetEdgesItemFromClientIdRegExp,
            )
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          fromContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
          maxCount: zod.int().nullish(),
          minCount: zod.int().nullish(),
          position: zod.int().nullish(),
          toClientId: zod
            .string()
            .min(1)
            .max(graphMutationApprovalPreviewResponseCanonicalMutationSetEdgesItemToClientIdMax)
            .regex(
              graphMutationApprovalPreviewResponseCanonicalMutationSetEdgesItemToClientIdRegExp,
            )
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          toContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        }),
      )
      .optional(),
    source: zod
      .object({
        messageContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        reachThreadId: zod.uuid().optional().describe('UUID v4 identifier'),
      })
      .optional(),
    subjectUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  }),
  canonicalPreview: zod.object({
    counts: zod.object({
      edgesRemoved: zod.int(),
      edgesSet: zod.int(),
      instancesCreated: zod.int(),
      lineagesDeleted: zod.int(),
      nodesEdited: zod.int(),
      typesCreated: zod.int(),
    }),
    edges: zod.array(
      zod.object({
        edgeType: zod.string().optional(),
        from: zod.string(),
        maxCount: zod.int().nullish(),
        minCount: zod.int().nullish(),
        operation: zod.enum(['set', 'remove']),
        to: zod.string(),
      }),
    ),
    nodes: zod.array(
      zod.object({
        after: zod.unknown().optional(),
        before: zod.unknown().optional(),
        changedFields: zod.array(zod.string()).optional(),
        clientId: zod.string().optional(),
        contentTypeName: zod.string().nullish(),
        contentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        label: zod.string(),
        lineageUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        operation: zod.enum(['create', 'edit', 'delete']),
        variant: zod.enum(['TYPE', 'INSTANCE']),
      }),
    ),
    records: zod.array(
      zod.object({
        afterDescription: zod.string().nullish(),
        afterLabel: zod.string().nullish(),
        afterValue: zod.unknown().optional(),
        beforeDescription: zod.string().nullish(),
        beforeLabel: zod.string().nullish(),
        beforeValue: zod.unknown().optional(),
        changeCount: zod.int(),
        children: zod.array(zod.unknown()),
        description: zod.string().nullish(),
        fieldKey: zod.string().nullish(),
        id: zod.string(),
        label: zod.string(),
        maxCount: zod.int().nullish(),
        minCount: zod.int().nullish(),
        occurredAt: zod.string().nullish(),
        operation: zod.enum(['create', 'edit', 'delete', 'unchanged']),
        position: zod.int().nullish(),
        reference: zod.boolean().optional(),
        typeName: zod.string().nullish(),
        valueType: zod.string().nullish(),
        variant: zod.enum(['TYPE', 'INSTANCE']),
      }),
    ),
    schemas: zod.array(
      zod.object({
        afterDescription: zod.string().nullish(),
        afterLabel: zod.string().nullish(),
        afterValue: zod.unknown().optional(),
        beforeDescription: zod.string().nullish(),
        beforeLabel: zod.string().nullish(),
        beforeValue: zod.unknown().optional(),
        changeCount: zod.int(),
        children: zod.array(zod.unknown()),
        description: zod.string().nullish(),
        fieldKey: zod.string().nullish(),
        id: zod.string(),
        label: zod.string(),
        maxCount: zod.int().nullish(),
        minCount: zod.int().nullish(),
        occurredAt: zod.string().nullish(),
        operation: zod.enum(['create', 'edit', 'delete', 'unchanged']),
        position: zod.int().nullish(),
        reference: zod.boolean().optional(),
        typeName: zod.string().nullish(),
        valueType: zod.string().nullish(),
        variant: zod.enum(['TYPE', 'INSTANCE']),
      }),
    ),
    warnings: zod.array(zod.string()),
  }),
  mutationHash: zod.string(),
});

export type GraphMutationApprovalPreviewResponse = zod.input<
  typeof GraphMutationApprovalPreviewResponse
>;
export type GraphMutationApprovalPreviewResponseOutput = zod.output<
  typeof GraphMutationApprovalPreviewResponse
>;
